import React from "react";
import styled from "styled-components";
import { Column, Text } from "../theme/index";
import badge from "../../assets/badge.png";
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 1px solid #1c334f;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  justify-self: center;
  grid-area: a;
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 40%;
  background-color: #ffaf77;
  margin: 0 auto;
`;

const Badge = styled.img`
  width: 150px;
  margin: 0.75em 0;
  @media (max-width: 400px) {
    margin: 1em 0;
  }
`;

export default function Accreditations({ approvedBy, accreditations }) {
  return (
    <Wrapper>
      <Text protitle>Accreditations</Text>
      <Div />
      <Column
        margin=".75em 0 0 0"
        alignitems="center"
        width="85%"
        textalign="center"
      >
        {!accreditations && (
          <React.Fragment>
            <Text testimony2 textalign="center" color="#2b2b2b">
              AchieveCE is Board Approved
            </Text>
            <Text margin="0" color="#2b2b2b">
              ---
            </Text>
            <Text
              margin=".75em 0"
              testimony2
              textalign="center"
              color="#2b2b2b"
            >
              Approval Number:
            </Text>
            <Text margin="0" testimony2 textalign="center" color="#2b2b2b">
              #20641
            </Text>
            <Badge src={badge} />
            <Text margin="0" testimony2 textalign="center" color="#2b2b2b">
              All courses report to CE broker in 24 hours
            </Text>
          </React.Fragment>
        )}
        {accreditations && <ReactMarkdown source={accreditations} />}
      </Column>
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Accreditations.jsx